import React, { Component } from 'react';
import { Route, Link, Switch } from "react-router-dom";
import PropTypes from 'prop-types';
import OrderlahLogoBar from './OrderlahLogoBar';
import LanguageSelect from './LanguageSelect';
import AppData from '../Model/AppData'
import CountDownTimer from './TopNavComponent/CountDownTimer';
import PendingPaymentTimer from './TopNavComponent/PendingPaymentTimer';
import MerchantInfoModal from '../jsx/modal/MerchantInfoModal/MerchantInfoModal';


class TopNav extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    confirmedOrder(e) {
        if (confirm(lang.asking_place_order)) {
            e.stopPropagation()
            let id = e.currentTarget.dataset.id * 1
            let order = this.props.orders.find((item) => item.id == id)

            $('#place-order-button').fadeOut('slow');

            $.ajax({
                url: "/orders/" + order.id + "/update_order_status",
                type: 'post',
                data: {
                    order_id: order.id,
                    merchant_id: order.merchant_id,
                    table_id: order.table_id,
                    order_status: "accepted"
                },
                success: (response) => {
                    alert(lang.order_complete)
                    this.forceUpdate();
                    console.log(response)
                }
            })
        }
    }

    joinTable() {
        let table_session = AppData.data.state.table_session
        if (table_session) {
            let message = lang.table_lock_pin.replace("<br>", "\n")
            let pin = prompt(message)
            if (pin == null) {
                return;
            }
            else if (pin != table_session.pin) { //PIN incorrect
                alert(lang.incorrect_pin_again)
                return
            }
            else { //PIN correct
                AppData.createTableSession(pin)
            }
        }
        else {
            // If this table do not has any active session,
            // "Join Table" button will not be shown. So
            // don't have to handle
        }
    }

    isLogoAppear(){
        if(AppData.data.isMerchantHasFeature('disable_logo_at_user_order_page')){
            return null
        }
        else {
            const customLogo = window.isProPlan && AppData.data.getMerchantSettingValue("merchant_custom_logo") || ""
            return <OrderlahLogoBar customLogo={customLogo} />
        }
    }

    render() {
        let actionButton = null;
        const isShowPendingPaymentTimer = AppData.data.state.table_session && AppData.data.state.table_session.pickup_confirmed_at
        if (this.props.action !== undefined) {
            let label = this.props.actionLabel !== undefined ? this.props.actionLabel : "+"
            actionButton = (<button className="pull-right btn btn-primary btn-sm" onClick={this.props.action}>{label}</button>);
        }

        let className = this.props.merchant ? "navbar navbar-default" : "navbar navbar-default navbar-fixed-top"
        className += " " + this.props.extraClassName

        let back = this.props.back
        let isShowTimer = window.isShowTimer
        let showCheckIn = this.props.showCheckIn
        
        let isSearch = AppData.data.state.isSearch && this.props.isAllowSearchbar

        const isShowMerchantInfoButton = AppData.data.getMerchantSettingValue("hide_merchant_info_button") != "1"
        return (
            <div>
                {/* Update nav bar height so that other component can adjust position based on this value */}
                <div ref={(ref) => {this.navHeight = ref && ref.clientHeight} }
                    className={className}>
                    <div className="container">
                        <div className="navbar-header" style={{ width: "100%", margin: "0px" }}>
                            {this.isLogoAppear()}
                            <Switch>
                                <Route path="/category/:tableQR" render={ props => <span className="navbar-inline-block pull-left" style={{margin:"0px", paddingTop:"10px",paddingLeft:"0px"}}><LanguageSelect merchant={this.props.merchantInfo} /></span> } />
                                <Route render={ props => {return null}} />
                            </Switch>
                            
                            {
                                this.props.backButton && this.props.back && !this.props.onBack &&
                                    <Link
                                        to={back}
                                        replace={!!this.props.replace}
                                        className="btn btn-link btn-xs pull-left navbar-btn "
                                        style={{ paddingLeft: "0px", paddingRight: "0px", }}>
                                        <span id="back-btn" className="glyphicon glyphicon-chevron-left"></span> <b>{this.props.backLabel}</b>
                                    </Link>
                            }
                            {
                                this.props.backButton && this.props.back && this.props.onBack &&
                                <a onClick={this.props.onBack} className="btn btn-link btn-xs pull-left navbar-btn" 
                                    style={{ paddingLeft: "0px", paddingRight: "0px", }}>
                                        <span id="back-btn" className="glyphicon glyphicon-chevron-left"></span> <b>Back</b>
                                    </a>
                            }

                            {
                                this.props.actionLabel ?
                                    this.props.actionLabel == lang.cancel ? 
                                        <button 
                                            onClick={this.props.action} 
                                            className="btn btn-danger pull-right navbar-btn">{this.props.actionLabel}
                                        </button> :
                                        <button
                                            onClick={this.props.action}
                                            className="btn btn-default pull-right navbar-btn">{this.props.actionLabel}
                                        </button>
                                    : null
                            }
                            {
                                this.props.btnImport ? 
                                    <button 
                                        onClick={this.props.btnImportAction}
                                        className="btn btn-default pull-right navbar-btn mr-2">Import CSV
                                    </button>
                                    : null
                            }
                            {
                                this.props.btnExport ? 
                                    <button 
                                        onClick={this.props.btnExportAction}
                                        className="btn btn-default pull-left navbar-btn">Export CSV
                                    </button>
                                    : null
                            }
                            {this.props.actionComponent ? this.props.actionComponent : null}
                            {isShowTimer && <CountDownTimer />}

                            {
                                isShowPendingPaymentTimer &&
                                <PendingPaymentTimer />
                            }
                            {
                                this.props.isAllowSearchbar && AppData.data.isMerchantHasFeature('user_app_allow_searchbox') &&
                                <button className={"btn btn-default pull-right navbar-btn " + (isSearch && "active") } onClick={() => AppData.data.triggerSearchbar(true)}><i className="fa fa-search"></i></button>
                            }
                            {/* check in button  hided*/}
                           {showCheckIn && <Link id="mainpage-btn-checkin"
                           
                                className="btn btn-default pull-right navbar-btn"
                                to={{
                                    pathname: `/check_in/${this.props.tableQR}`,
                                    state: {
                                        hideFooter: true
                                    }
                                }}>
                                <span style={{ fontSize: "12px" }}>{lang.check_in}</span>
                            </Link>}

                            {
                                isShowMerchantInfoButton &&
                                <button className="btn btn-default pull-right navbar-btn mr-2" style={{borderRadius:"50%", width: "36px", height: "36px"}} onClick={this.showMerchantInfo}>
                                    <span style={{ fontSize: "12px" }}><i className="fa fa-info"/></span>
                                </button>
                            }
                        </div>
                    </div>
                    <div className="clearfix"></div>
                    {
                        isSearch &&
                        <div style={{display: "block", width: "100%", padding: "0px 5px"}}>
                            <div className="container" style={{display: "flex", position: "relative"}}>
                                <input type="search" className="form-control" value={AppData.data.state.searchText || ""} placeholder={lang.searchbar_placeholder} onChange={AppData.data.onSearchTextChange} />
                                {
                                    AppData.data.state.searchText &&
                                    <button style={{position: "absolute", right: "15px"}} class="btn btn-outline-secondary border-left-0 rounded-0 rounded-right" type="button" onClick={AppData.data.onClearSearchTextClicked}>
                                        <i class="fa fa-times"></i>
                                    </button>
                                }
                            </div>
                        </div>
                    }
                    {this.props.navbar}
                    {
                        this.state.merchantInfoModal
                    }
                </div>
            </div>
        );
    }
    showMerchantInfo = () => {
        const onClose = () => {
            this.setState({
                merchantInfoModal: null
            })
        }

        let theModal = <MerchantInfoModal 
            onClose={onClose}
            onYes={onClose}
            merchant={this.props.merchantInfo}
            app={AppData.data}
        />

        this.setState({
            merchantInfoModal: theModal
        })
    }

    getOrderBill(tableID) {
        if (AppData.data.state.table_session) {
            if (table_session_id == null || this.props.orders === undefined || this.props.orders === null) {
                // This table already has an active session, however this user has yet to join the session
                // Show Join Table button to allow join table
                return <button onClick={this.joinTable.bind(this)} className="navbar-btn btn btn-sm btn-default pull-right" >
                    {lang.join_table || "Join Table"}
                </button>
            }

            // User already joined, proceed to below handling
        }
        else {
            // This table has no active session, show nothing.
            // User can trigger to create a new session by ordering
            // any item from the menu
            return null
        }

        let count = (this.props.orders || []).filter((order) => order.order_status == "draft").length
        let draft = false
        let orderId = 0;
        (this.props.orders || []).map((order) => {
            if (order.order_status == "draft") {
                draft = true;
                orderId = order.id;
            }
        })

        if (draft) {
            var flash = setInterval(function () {
                $('#category-place-order-button').fadeTo('slow', 0.5).fadeTo('slow', 1.0);
            }, 3000)
        }
        else {
            clearInterval(flash);
        }

        let countDotStyle = {
            position: "absolute",
            top: "-5px",
            left: "35px",
        }
        let cartStyle = {
            fontSize: "16pt",
            position: "absolute",
            color: "#F99F2499",
        }

        return (
            <div key={"category-" + tableID} className="navbar-btn">
                <Link id="bill-button" to={`/order/${this.props.tableQR}`} className="pull-right" style={{padding:"8px", marginRight:"30px",position:"relative"}}>
                    <span style={{ marginLeft: "6px" }}><i style={cartStyle} className="fas fa-shopping-cart"></i>
                        {count > 0 ? <span id="bill-count" className="label label-danger pull-right order_dot" key="1" style={countDotStyle}>{count}</span> : ""}
                    </span>
                </Link>
            </div>
        )
    }
}
TopNav.propTypes = {
    table: PropTypes.object,
    orders: PropTypes.array,
    title: PropTypes.string.isRequired,
    action: PropTypes.func,
    actionLabel: PropTypes.string,
    back: PropTypes.string,
    backLabel: PropTypes.string,
    // pin: PropTypes.object,
    session: PropTypes.object,
    backButton: PropTypes.bool,
    merchant: PropTypes.bool,
    adminOrdering: PropTypes.bool,
    showCheckIn: PropTypes.bool,
}
TopNav.defaultProps = {
    back: "/",
    topTitle: "",
    backTitle: lang.back,
    backButton: true,
    merchant: false,
    adminOrdering: false,
    showCheckIn: false,
}


export default TopNav;